import { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../services/firebase';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  // React Router hook to redirect the user after they log in
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Ping Firebase Auth
      await signInWithEmailAndPassword(auth, email, password);
      
      // If successful, our global AuthContext will automatically catch the state change.
      // We route them straight into the command center.
      navigate('/');
    } catch (err) {
      console.error("Authentication failed:", err);
      setError('Invalid credentials or unauthorized access.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-50">
      <div className="w-full max-w-md p-8 bg-white rounded-xl shadow-lg border border-slate-200">
        
        {/* Brand Header with Logo and Tagline */}
        <div className="flex flex-col items-center text-center mb-8">
          <div className="w-12 h-12 mb-4">
            <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 2L2 9L16 16L30 9L16 2Z" fill="#10B981" fillOpacity="0.1" stroke="#10B981" strokeWidth="1.5" strokeLinejoin="round"/>
              <path d="M2 23L16 30L30 23V9L16 16L2 9V23Z" fill="#0F172A" />
              <path d="M2 23L16 30L30 23" stroke="#10B981" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M16 30V16" stroke="#10B981" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="16" cy="16" r="2.5" fill="#06B6D4" className="animate-pulse" /> {/* cyan-500 to pop on white */}
            </svg>
          </div>
          <h2 className="text-3xl font-extrabold text-slate-800 tracking-tight flex items-baseline justify-center">
            eeko<span className="font-light text-slate-500">System</span>
          </h2>
          <div className="mt-2 text-[0.6rem] font-bold tracking-[0.25em] text-slate-400 uppercase whitespace-nowrap">
            AN APE<span className="text-cyan-500 font-black">X</span> RETAIL-SUITE TOOL
          </div>
        </div>

        {error && (
          <div className="mb-6 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm text-center font-medium">
            {error}
          </div>
        )}

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-sm font-bold text-slate-700 mb-2">Email Address</label>
            <input 
              type="email" 
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-slate-50 border border-slate-300 rounded-lg p-3 text-slate-800 focus:outline-none focus:border-emerald-600 focus:ring-2 focus:ring-emerald-600/20 transition-all font-medium"
              placeholder="admin@example.com"
            />
          </div>

          <div>
            <label className="block text-sm font-bold text-slate-700 mb-2">Password</label>
            <input 
              type="password" 
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-slate-50 border border-slate-300 rounded-lg p-3 text-slate-800 focus:outline-none focus:border-emerald-600 focus:ring-2 focus:ring-emerald-600/20 transition-all font-medium"
              placeholder="••••••••"
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-3 px-4 rounded-lg transition-colors shadow-sm disabled:opacity-50 mt-4"
          >
            {loading ? 'Authenticating...' : 'Secure Login'}
          </button>
        </form>
      </div>
    </div>
  );
}